<template>
  <div class="modal-overlay">
    <ModalContent class="modal-content">
      <DocPrintsArea>
        <!-- ! 인쇄 설정 -->
        <DocPrintsBtnArea>
          <DocPrintsOptionArea class="table-style-controls">
            <DocPrintsOptionTitle>인쇄 설정</DocPrintsOptionTitle>
            <label>
              열 높이:
              <input v-model="trHeight" @input="onlyNumber($event.target.value, 'trHeight')" type="text" />
            </label>
            <label>
              칸 너비:
              <input v-model="tdWidth" @input="onlyNumber($event.target.value, 'tdWidth')" type="text" />
            </label>
          </DocPrintsOptionArea>
          <br />
          <DocPrintsBtn @click="convertToPDF">
            <FileDocument />&nbsp;&nbsp;&nbsp;PDF변환
          </DocPrintsBtn>
          <DocPrintsBtn @click="printOne">
            <PrinterOutline />&nbsp;&nbsp;&nbsp;한장프린트
          </DocPrintsBtn>
          <DocPrintsBtn @click="printAll">
            <PrinterOutline />&nbsp;&nbsp;&nbsp;전체프린트
          </DocPrintsBtn>
          <DocPrintsBtn @click="sendFax">
            <Fax />&nbsp;&nbsp;&nbsp;팩스발송
          </DocPrintsBtn>
          <DocPrintsBtn @click="sendSms">
            <MessageProcessing />&nbsp;&nbsp;&nbsp;SMS발송
          </DocPrintsBtn>
          <!-- <DocPrintsBtn @click="sendTaxInvoice">
            <InvoiceTextSendOutline />&nbsp;&nbsp;&nbsp;전자세금계산서 작성
          </DocPrintsBtn>
          <DocPrintsBtn @click="sendStatement">
            <InvoiceTextSendOutline />&nbsp;&nbsp;&nbsp;전자명세서 작성
          </DocPrintsBtn>
          <DocPrintsBtn @click="sendCashReceipt">
            <InvoiceTextSendOutline />&nbsp;&nbsp;&nbsp;현금영수증 작성
          </DocPrintsBtn> -->
        </DocPrintsBtnArea>

        <!-- ! 미리보기 -->
        <div class="preview-container" id="printContent">
          <DocPrintsTabArea>
            <DocPrintsTab :class="{ active: activeTab === '거래명세서' }" @click="handleTabClick('거래명세서', 0)">
              <DocPrintInput type="checkbox" :checked="checkedTabs.includes('거래명세서')"
                @change="handleCheckboxChange('거래명세서')" />
              거래명세서
            </DocPrintsTab>
            <DocPrintsTab :class="{ active: activeTab === '세금계산서' }" @click="handleTabClick('세금계산서', 1)">
              <DocPrintInput type="checkbox" :checked="checkedTabs.includes('세금계산서')"
                @change="handleCheckboxChange('세금계산서')" />
              세금계산서
            </DocPrintsTab>
            <DocPrintsTab :class="{ active: activeTab === '견적서' }" @click="handleTabClick('견적서', 2)">
              <DocPrintInput type="checkbox" :checked="checkedTabs.includes('견적서')"
                @change="handleCheckboxChange('견적서')" /> 견적서
            </DocPrintsTab>
          </DocPrintsTabArea>
          <!-- * 미리보기 페이지 -->
          <PreviewPageDiv class="preview-page">
            <div v-html="currentPageContent"></div>
          </PreviewPageDiv>
        </div>
      </DocPrintsArea>
      <DocPrintsArrowArea class="modal-footer">
        <h2>인쇄 미리보기<span> &nbsp;{{ currentPageIndex + 1 }} / {{ displayPageCount }}</span></h2>&nbsp;&nbsp;&nbsp;
        <DocPrintsArrowBtn @click="prevPage" :disabled="currentPageIndex === 0">
          <ArrowLeftBold />
        </DocPrintsArrowBtn>
        <DocPrintsArrowBtn @click="nextPage" :disabled="currentPageIndex === localPageUrls.length - 1">
          <ArrowRightBold />
        </DocPrintsArrowBtn>
      </DocPrintsArrowArea>
    </ModalContent>
  </div>

  <!-- * Fax 발송 -->
  <ModalPage v-model:show="showModal_obj.fax" :width="modal_width.fax" :height="modal_height.fax">
    <FaxModal @close="showModal_obj.fax = false" />
  </ModalPage>

  <!-- * SMS 발송 -->
  <ModalPage v-model:show="showModal_obj.sms" :width="modal_width.sms" :height="modal_height.sms">
    <SmsModal :name="client_data_obj?.name" :number="client_data_obj?.number" :guardname="client_data_obj?.guardname"
      :phone1="client_data_obj?.phone1" :phone2="client_data_obj?.phone2" @close="showModal_obj.sms = false" />
  </ModalPage>
</template>

<script>
import { ref, nextTick, reactive } from 'vue';

import ModalPage from '@/components/layout/ModalPage.vue';
import SmsModal from '@/components/order/modal/SmsModal.vue';
import FaxModal from '@/components/order/modal/FaxModal.vue';
import * as DocPrintsCss from '@/assets/styles/order/modal/DocPrintsCss';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

import FileDocument from 'vue-material-design-icons/FileDocument.vue';
import ArrowRightBold from 'vue-material-design-icons/ArrowRightBold.vue';
import ArrowLeftBold from 'vue-material-design-icons/ArrowLeftBold.vue';
import Fax from 'vue-material-design-icons/Fax.vue';
import MessageProcessing from 'vue-material-design-icons/MessageProcessing.vue';
import PrinterOutline from 'vue-material-design-icons/PrinterOutline.vue';
// import InvoiceTextSendOutline from 'vue-material-design-icons/InvoiceTextSendOutline.vue';

export default {
  name: 'PrintPreviewModal',

  components: {
    ...DocPrintsCss,
    FileDocument, ArrowRightBold, ArrowLeftBold, Fax, MessageProcessing, PrinterOutline,
    ModalPage,
    SmsModal, FaxModal
  },

  props: {
    pageUrls: {
      type: Array,
      default: () => [
        './btransactionfileNew.html',    // 거래명세서 템플릿
        './taxfileNew.html',             // 세금계산서 템플릿
        './estimatefileNew.html',         // 견적서 템플릿
      ]
    },
    products_obj: {
      type: Array,
      default: () => []
    },
    client_data_obj: {
      type: Object,
      default: () => { }
    },
    postcode_obj: {
      type: Object,
      default: () => { }
    },
  },
  emits: ['close'],

  data() {
    return {
      activeTab: '거래명세서',
      checkedTabs: ['거래명세서'],
      defaultUrls: [
        './btransactionfileNew.html',    // 거래명세서 템플릿
        './taxfileNew.html',             // 세금계산서 템플릿
        './estimatefileNew.html',         // 견적서 템플릿
      ],
      localPageUrls: [],
      supplierInfo: {
        registrationNumber: '',  // company_bnum
        businessNumber: '',      // company_bnum
        name: '',               // company
        representative: '',      // company_ceo_name
        address: '',            // company_address
        business: '',           // company_type
        item: '',               // company_industry
        email: '',              // company_email
        manager: '',            // user_name
        phone: ''               // company_phone
      },
      receiverInfo: {
        registrationNumber: '',
        businessNumber: '',
        name: '',
        representative: '',
        address: '',
        business: '',
        item: '',
        email: ''
      },
      taxItems: [],
      paymentInfo: {
        cash: '',
        check: 0,
        note: 0,
        credit: 0
      }
    }
  },

  setup(props, { emit }) {
    const currentPageIndex = ref(0);
    const currentPageContent = ref('');
    const trHeight = ref('40');
    const tdWidth = ref('80');

    const modal_width = reactive({
      sms: '45%',
      fax: '45%',
    });

    const modal_height = reactive({
      sms: '60%',
      fax: '60%',
    });

    const showModal_obj = reactive({
      sms: ref(false),
      fax: ref(false),
    });

    return {
      currentPageIndex,
      currentPageContent,
      trHeight,
      tdWidth,
      showModal_obj,
      modal_width,
      modal_height,
      emit
    };
  },

  computed: {
    isTestUser() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        return userInfo && userInfo.id === 'test';
      } catch (error) {
        return false;
      }
    },
    displayPageCount() {
      return this.localPageUrls.length || this.defaultUrls.length;
    }
  },

  methods: {
    // 로컬스토리지에서 공급자 정보 로드 (companykey 추가)
    loadSupplierInfoFromStorage() {
      try {
        // 전역 상태에서 공급자 정보 가져오기
        const globalState = this.$globalState || {};

        this.supplierInfo = {
          registrationNumber: globalState.company_bnum || '',
          businessNumber: globalState.company_bnum || '',
          name: globalState.company || globalState.company_name || '',
          representative: globalState.company_ceo_name || '',
          address: globalState.company_address || '',
          business: globalState.company_type || '',
          item: globalState.company_industry || '',
          email: globalState.company_email || '',
          manager: globalState.user_name || globalState.manager_name || '',
          phone: globalState.company_phone || '',
          companykey: globalState.company_key || globalState.companykey || '' // companykey 추가
        };
      } catch (error) {
        console.error('공급자 정보 로드 중 오류:', error);
      }
    },

    handleTabClick(tabName, pageIndex) {
      if (this.activeTab === tabName) { // 같은 탭을 다시 클릭한 경우
        this.activeTab = '';
        this.checkedTabs = [];
      } else { // 다른 탭을 클릭한 경우
        this.activeTab = tabName;
        this.currentPageIndex = pageIndex;
        this.checkedTabs = [tabName]; // 현재 탭만 체크되도록 배열 교체
        // 해당 탭의 페이지 로드
        this.loadPage(this.localPageUrls[pageIndex]);
      }
    },

    // 체크박스 변경 핸들러 수정
    handleCheckboxChange(tabName) {
      if (this.checkedTabs.includes(tabName)) { // 체크 해제
        this.checkedTabs = [];
        this.activeTab = '';
      } else { // 체크
        this.checkedTabs = [tabName]; // 현재 탭만 체크되도록 배열 교체
        this.activeTab = tabName;
        this.currentPageIndex = this.getIndexByTabName(tabName);
      }
    },
    // 탭 이름으로 페이지 인덱스 가져오기
    getIndexByTabName(tabName) {
      const tabNames = ['거래명세서', '세금계산서', '견적서'];
      return tabNames.indexOf(tabName);
    },
    // 페이지 인덱스로 탭 이름 가져오기
    getTabNameByIndex(index) {
      const tabNames = ['거래명세서', '세금계산서', '견적서'];
      return tabNames[index];
    },
    async convertToPDF() {
      const pdf = new jsPDF();
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const margin = 20;

      for (let i = 0; i < this.localPageUrls.length; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        await this.loadPage(this.localPageUrls[i]);
        const content = document.getElementById('printContent');

        const tabAreas = content.querySelectorAll('.DocPrintsTabArea, .DocPrintsTab, .preview-container > div:first-child, .preview-container > *:first-child');
        const hiddenElements = [];
        tabAreas.forEach(el => {
          if (el && el.style.display !== 'none') {
            hiddenElements.push({ el, display: el.style.display });
            el.style.display = 'none';
          }
        });

        const canvas = await html2canvas(content, {
          scale: 2,
        });

        // 숨긴 요소 복원
        hiddenElements.forEach(({ el, display }) => {
          el.style.display = display;
        });

        const imgData = canvas.toDataURL('image/png');

        const imgWidth = pdfWidth - (margin * 2);
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(imgData, 'PNG', margin, margin, imgWidth, imgHeight);

        if (imgHeight > pdfHeight - (margin * 2)) {
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', margin, margin - (pdfHeight - (margin * 2)), imgWidth, imgHeight);
        }
      }

      pdf.save('document.pdf');
    },
    async loadPage(url) {
      try {
        let html;

        // ✅ 일렉트론 환경에서 IPC를 통해 파일 읽기
        if (window.electronAPI && window.electronAPI.isElectron) {
          const targetUrl = url || this.localPageUrls[this.currentPageIndex] || this.defaultUrls[this.currentPageIndex];

          // URL에서 파일명 추출
          let fileName;
          if (targetUrl.includes('btransactionfileNew.html')) {
            fileName = 'btransactionfileNew.html';
          } else if (targetUrl.includes('taxfileNew.html')) {
            fileName = 'taxfileNew.html';
          } else if (targetUrl.includes('estimatefileNew.html')) {
            fileName = 'estimatefileNew.html';
          } else if (targetUrl.includes('standardcontractfileNew.html')) {
            fileName = 'standardcontractfileNew.html';
          } else {
            throw new Error('지원하지 않는 파일 형식입니다.');
          }

          const result = await window.electronAPI.readHtmlFile(fileName);

          if (!result.success) {
            throw new Error(result.error || 'HTML 파일 읽기 실패');
          }

          html = result.content;

        } else {
          // ✅ 웹 환경에서는 기존 fetch 방식 사용
          const targetUrl = url || this.localPageUrls[this.currentPageIndex] || this.defaultUrls[this.currentPageIndex];
          const response = await fetch(targetUrl);
          html = await response.text();
        }

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // 문서 종류에 따른 처리
        // 거래명세서 처리
        const targetUrl = url || this.localPageUrls[this.currentPageIndex] || this.defaultUrls[this.currentPageIndex];
        if (targetUrl.includes('btransactionfileNew.html')) {
          this.handleTransactionDocument(doc);
          // 세금계산서 처리
        } else if (targetUrl.includes('taxfileNew.html')) {
          this.handleTaxDocument(doc);
          // 견적서 처리
        } else if (targetUrl.includes('estimatefileNew.html')) {
          this.handleEstimateDocument(doc);
        }

        html = doc.documentElement.outerHTML;
        this.currentPageContent = html;
        await nextTick();
        this.applyTableStyles();

      } catch (error) {
        console.error('페이지 로딩 오류:', error);
        this.currentPageContent = '<p>페이지 내용을 불러오는 중 오류가 발생했습니다</p>';
      }
    },
    // 세금계산서 처리 수정 - handleTaxDocument 메서드
    // 세금계산서 처리 - 블러 처리 추가
    handleTaxDocument(doc) {
      // 승인번호 설정
      const reg_date = doc.querySelector('.reg_date');
      if (reg_date) {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        const dateStr = `${year}${month}${day}`;
        const randomNum = Math.floor(10000000 + Math.random() * 90000000).toString().substring(0, 8);
        reg_date.textContent = `${dateStr}-${randomNum}`;

        if (this.isTestUser) reg_date.classList.add('blurred');
      }

      // 공급자 정보 설정 - 블러 처리 추가
      const allRows = doc.querySelectorAll('tr');
      allRows.forEach(row => {
        const cells = row.querySelectorAll('td');
        cells.forEach((cell) => {
          const cellText = cell.textContent.trim();
          const isSupplierCell = cell.classList.contains('tg-dzut') || cell.classList.contains('tg-rl9a');

          if (isSupplierCell && cellText !== '공급자') {
            if (cellText === '등록번호') {
              const nextCell = cell.nextElementSibling;
              if (nextCell && nextCell.classList.contains('tg-6p27')) {
                nextCell.textContent = this.supplierInfo.registrationNumber || '';
                if (this.isTestUser) nextCell.classList.add('blurred');
              }
            } else if (cellText.includes('상호') || cellText.includes('법인명')) {
              const nextCell = cell.nextElementSibling;
              if (nextCell && nextCell.classList.contains('tg-6p27')) {
                nextCell.textContent = this.supplierInfo.name || '';
                if (this.isTestUser) nextCell.classList.add('blurred');
              }
            } else if (cellText === '성명') {
              const nextCell = cell.nextElementSibling;
              if (nextCell && nextCell.classList.contains('tg-6p27')) {
                nextCell.textContent = this.supplierInfo.representative || '';
                if (this.isTestUser) nextCell.classList.add('blurred');
              }
            } else if (cellText.includes('사업장') && cellText.includes('주소')) {
              const nextCell = cell.nextElementSibling;
              if (nextCell && nextCell.classList.contains('tg-6p27')) {
                nextCell.textContent = this.supplierInfo.address || '';
                if (this.isTestUser) nextCell.classList.add('blurred');
              }
            } else if (cellText === '업태') {
              const nextCell = cell.nextElementSibling;
              if (nextCell && nextCell.classList.contains('tg-6p27')) {
                nextCell.textContent = this.supplierInfo.business || '';
                if (this.isTestUser) nextCell.classList.add('blurred');
              }
            } else if (cellText === '종목') {
              const nextCell = cell.nextElementSibling;
              if (nextCell && nextCell.classList.contains('tg-6p27')) {
                nextCell.textContent = this.supplierInfo.item || '';
                if (this.isTestUser) nextCell.classList.add('blurred');
              }
            } else if (cellText === '이메일') {
              const nextCell = cell.nextElementSibling;
              if (nextCell && nextCell.classList.contains('tg-36ox')) {
                nextCell.textContent = this.supplierInfo.email || '';
                if (this.isTestUser) nextCell.classList.add('blurred');
              }
            }
          }
        });
      });

      // 공급받는자 정보 설정 - 블러 처리 추가
      allRows.forEach(row => {
        const cells = row.querySelectorAll('td');
        cells.forEach((cell) => {
          const cellText = cell.textContent.trim();
          const isClientCell = cell.classList.contains('tg-3l6l');

          if (isClientCell && cellText !== '공급받는자') {
            if (cellText === '등록번호') {
              const nextCell = cell.nextElementSibling;
              if (nextCell && nextCell.classList.contains('tg-ooms')) {
                nextCell.textContent = this.client_data_obj.company_bnum || '';
                if (this.isTestUser) nextCell.classList.add('blurred');
              }
            } else if (cellText.includes('상호') || cellText.includes('법인명')) {
              const nextCell = cell.nextElementSibling;
              if (nextCell && nextCell.classList.contains('tg-ooms')) {
                nextCell.textContent = this.client_data_obj.company || '';
                if (this.isTestUser) nextCell.classList.add('blurred');
              }
            } else if (cellText === '성명') {
              const nextCell = cell.nextElementSibling;
              if (nextCell && nextCell.classList.contains('tg-ooms')) {
                nextCell.textContent = this.client_data_obj.company_ceo_name || '';
                if (this.isTestUser) nextCell.classList.add('blurred');
              }
            } else if (cellText.includes('사업장') && cellText.includes('주소')) {
              const nextCell = cell.nextElementSibling;
              if (nextCell && nextCell.classList.contains('tg-ooms')) {
                let address = '';
                if (this.postcode_obj && this.postcode_obj.address1) {
                  address = `${this.postcode_obj.address1} ${this.postcode_obj.detailAddress1 || ''}`.trim();
                } else if (this.client_data_obj.company_address) {
                  address = this.client_data_obj.company_address;
                }
                nextCell.textContent = address;
                if (this.isTestUser) nextCell.classList.add('blurred');
              }
            } else if (cellText === '업태') {
              const nextCell = cell.nextElementSibling;
              if (nextCell && nextCell.classList.contains('tg-ooms')) {
                nextCell.textContent = this.client_data_obj.company_type || '';
                if (this.isTestUser) nextCell.classList.add('blurred');
              }
            } else if (cellText === '종목') {
              const nextCell = cell.nextElementSibling;
              if (nextCell && nextCell.classList.contains('tg-ooms')) {
                nextCell.textContent = this.client_data_obj.company_industry || '';
                if (this.isTestUser) nextCell.classList.add('blurred');
              }
            } else if (cellText === '이메일') {
              const nextCell = cell.nextElementSibling;
              if (nextCell && nextCell.classList.contains('tg-ooms')) {
                nextCell.textContent = this.client_data_obj.company_email || '';
                if (this.isTestUser) nextCell.classList.add('blurred');
              }
            }
          }
        });
      });

      // 날짜 처리 - 블러 처리 추가
      let orderDate;
      if (this.client_data_obj.orderdate) {
        const dateStr = this.client_data_obj.orderdate;
        if (dateStr.length === 8) {
          const year = dateStr.substring(0, 4);
          const month = dateStr.substring(4, 6);
          const day = dateStr.substring(6, 8);
          orderDate = new Date(`${year}-${month}-${day}`);
        } else {
          orderDate = new Date(this.client_data_obj.orderdate);
        }
      } else {
        orderDate = new Date();
      }

      if (isNaN(orderDate.getTime())) {
        orderDate = new Date();
      }

      const year = orderDate.getFullYear();
      const month = String(orderDate.getMonth() + 1).padStart(2, '0');
      const day = String(orderDate.getDate()).padStart(2, '0');

      const writeDateEl = doc.querySelector('#writeDate');
      if (writeDateEl) {
        writeDateEl.textContent = `${year}-${month}-${day}`;
        if (this.isTestUser) writeDateEl.classList.add('blurred');
      }

      // 제품 정보 처리 - 블러 처리 추가
      if (this.products_obj && this.products_obj.length > 0) {
        const tbody = doc.querySelector('#products_tbody');
        if (tbody) {
          tbody.innerHTML = '';

          this.products_obj.forEach((product) => {
            const row = document.createElement('tr');

            const productName = parseInt(product.b_product_id) >= 1000000 ? product.name3 : product.name2;
            const unitPrice = parseInt(product.rentprice) < 1 ? parseInt(product.setBuyprice) : parseInt(product.setRentprice);
            const quantity = product.quantity;
            const supplyPrice = unitPrice * quantity;
            const tax = Math.floor(supplyPrice * 0.1);

            row.innerHTML = `
              <td class="tg-c3ow">${month}</td>
              <td class="tg-c3ow">${day}</td>
              <td class="tg-0pky">${productName}</td>
              <td class="tg-c3ow"></td>
              <td class="tg-c3ow">${quantity}</td>
              <td class="tg-dvpl">${unitPrice.toLocaleString('ko-KR')}</td>
              <td class="tg-dvpl">${supplyPrice.toLocaleString('ko-KR')}</td>
              <td class="tg-dvpl">${tax.toLocaleString('ko-KR')}</td>
              <td class="tg-c3ow"></td>
            `;

            // test 사용자인 경우 모든 셀에 블러 처리
            if (this.isTestUser) {
              const cells = row.querySelectorAll('td');
              cells.forEach(cell => cell.classList.add('blurred'));
            }

            tbody.appendChild(row);
          });
        }
      }

      // 공급가액, 세액 등 계산 - 블러 처리 추가
      if (this.products_obj.length > 0) {
        const totalWithTax = this.products_obj.reduce((acc, item) =>
          acc + (parseInt(item.rentprice) < 1 ? parseInt(item.setBuyprice) : parseInt(item.setRentprice)), 0);

        const supplyPrice = Math.floor(totalWithTax / 1.1);
        const tax = totalWithTax - supplyPrice;

        const supplyPriceEl = doc.querySelector('#supplyPrice');
        if (supplyPriceEl) {
          supplyPriceEl.textContent = supplyPrice.toLocaleString('ko-KR');
          if (this.isTestUser) supplyPriceEl.classList.add('blurred');
        }

        const taxAmountEl = doc.querySelector('#taxAmount');
        if (taxAmountEl) {
          taxAmountEl.textContent = tax.toLocaleString('ko-KR');
          if (this.isTestUser) taxAmountEl.classList.add('blurred');
        }

        const totalAmountEl = doc.querySelector('#totalAmount');
        if (totalAmountEl) {
          totalAmountEl.textContent = totalWithTax.toLocaleString('ko-KR');
          if (this.isTestUser) totalAmountEl.classList.add('blurred');
        }
      }
    },

    // 견적서 처리 메서드 - 클래스 기반 처리
    handleEstimateDocument(doc) {
      if (!this.products_obj || !this.client_data_obj) return;

      // 사업자번호 설정
      const supplierRegNumberEl = doc.querySelector('.supplier-reg-number');
      if (supplierRegNumberEl) {
        supplierRegNumberEl.textContent = this.supplierInfo.registrationNumber || '';
        if (this.isTestUser) supplierRegNumberEl.classList.add('blurred');
      }

      // 상호 설정
      const supplierNameEl = doc.querySelector('.supplier-name');
      if (supplierNameEl) {
        supplierNameEl.textContent = this.supplierInfo.name || '';
        if (this.isTestUser) supplierNameEl.classList.add('blurred');
      }

      // 대표자 설정
      const supplierCeoEl = doc.querySelector('.supplier-ceo');
      if (supplierCeoEl) {
        supplierCeoEl.innerHTML = '';
        const nameText = document.createTextNode(this.supplierInfo.representative || '');
        supplierCeoEl.appendChild(nameText);

        if (this.isTestUser) supplierCeoEl.classList.add('blurred');

        // AWS S3에서 도장 이미지 동적으로 추가
        const stampImg = document.createElement('img');
        const stampExtensions = ['png', 'jpg', 'jpeg'];
        let currentExtensionIndex = 0;
        let s3Url = '';

        const tryNextExtension = () => {
          if (currentExtensionIndex >= stampExtensions.length) {
            console.warn('모든 확장자로 도장 이미지를 찾을 수 없습니다');
            return;
          }

          const extension = stampExtensions[currentExtensionIndex];
          s3Url = `${this.$apiUrls.s3Bucket}/Company-image/${this.supplierInfo.companykey}/stamp.${extension}`;
          stampImg.src = s3Url;
        };

        stampImg.className = 'stamp-img';
        stampImg.style.cssText = 'position: absolute; right: 1px; top: 50%; transform: translateY(-50%); width: 40px; height: 40px; object-fit: contain; background: transparent; mix-blend-mode: multiply;';

        stampImg.onerror = () => {
          console.warn(`도장 이미지 로드 실패 (${stampExtensions[currentExtensionIndex]}):`, s3Url);
          currentExtensionIndex++;

          if (currentExtensionIndex < stampExtensions.length) {
            tryNextExtension();
          } else {
            if (stampImg.parentNode) {
              stampImg.parentNode.removeChild(stampImg);
            }
            stampImg.style.display = 'none';
            stampImg.style.visibility = 'hidden';
            stampImg.style.opacity = '0';
            stampImg.style.width = '0';
            stampImg.style.height = '0';
            stampImg.style.position = 'absolute';
            stampImg.style.left = '-9999px';
          }
        };

        tryNextExtension();
        supplierCeoEl.appendChild(stampImg);
      }

      // 소재지 설정
      const supplierAddressEl = doc.querySelector('.supplier-address');
      if (supplierAddressEl) {
        supplierAddressEl.textContent = this.supplierInfo.address || '';
        if (this.isTestUser) supplierAddressEl.classList.add('blurred');
      }

      // 업태 설정
      const supplierBusinessEl = doc.querySelector('.supplier-business');
      if (supplierBusinessEl) {
        supplierBusinessEl.textContent = this.supplierInfo.business || '';
        if (this.isTestUser) supplierBusinessEl.classList.add('blurred');
      }

      // 종목 설정
      const supplierItemEl = doc.querySelector('.supplier-item');
      if (supplierItemEl) {
        supplierItemEl.textContent = this.supplierInfo.item || '';
        if (this.isTestUser) supplierItemEl.classList.add('blurred');
      }

      // 담당자 설정
      const supplierManagerEl = doc.querySelector('.supplier-manager');
      if (supplierManagerEl) {
        supplierManagerEl.textContent = this.supplierInfo.manager || '';
        if (this.isTestUser) supplierManagerEl.classList.add('blurred');
      }

      // 연락처 설정
      const supplierPhoneEl = doc.querySelector('.supplier-phone');
      if (supplierPhoneEl) {
        supplierPhoneEl.textContent = this.supplierInfo.phone || '';
        if (this.isTestUser) supplierPhoneEl.classList.add('blurred');
      }

      // 고객 정보 설정
      const clientNameEl = doc.querySelector('.client-name-cell');
      if (clientNameEl) {
        clientNameEl.textContent = `${this.client_data_obj.name || ''} 귀하`;
        if (this.isTestUser) clientNameEl.classList.add('blurred');
      }

      // 발행일 설정
      const issueDateEl = doc.querySelector('.issue-date-cell');
      if (issueDateEl) {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');

        issueDateEl.textContent = `발행일 : ${year}년 ${month}월 ${day}일`;
        if (this.isTestUser) issueDateEl.classList.add('blurred');
      }

      // 견적 내용 테이블 처리
      const itemTableBody = doc.querySelector('#itemTableBody');

      if (itemTableBody) {
        const existingRows = itemTableBody.querySelectorAll('.item-row');
        existingRows.forEach(row => row.remove());

        this.products_obj.forEach((product, index) => {
          const tr = document.createElement('tr');
          tr.className = 'item-row';

          const price = product.selected_target === '구입' ?
            parseInt(product.buyprice) :
            parseInt(product.rentprice);
          const amount = price * parseInt(product.quantity);

          const productName = parseInt(product.b_product_id) >= 1000000 ? product.name3 : product.name2;
          const icode = product.icode ? ` (${product.icode})` : '';

          tr.innerHTML = `
            <td class="tg-nrix center">${index + 1}</td>
            <td class="tg-cly1">${productName}${icode}</td>
            <td class="tg-nrix center">${product.options && product.options.size ? product.options.size[0] || '' : ''}</td>
            <td class="tg-nrix center">${product.quantity}</td>
            <td class="tg-mwxe right">${price.toLocaleString('ko-KR')}</td>
            <td class="tg-mwxe amount right">${amount.toLocaleString('ko-KR')}</td>
            <td class="tg-nrix center">${product.notes && product.notes[0] ? product.notes[0] : ''}</td>
          `;

          // test 사용자인 경우 모든 셀에 블러 처리
          if (this.isTestUser) {
            const cells = tr.querySelectorAll('td');
            cells.forEach(cell => cell.classList.add('blurred'));
          }

          const totalRow = itemTableBody.querySelector('.total-row');
          if (totalRow) {
            itemTableBody.insertBefore(tr, totalRow);
          } else {
            itemTableBody.appendChild(tr);
          }
        });

        // 합계 계산 및 업데이트
        const totalAmount = this.products_obj.reduce((acc, item) => {
          const price = item.selected_target === '구입' ?
            parseInt(item.buyprice) :
            parseInt(item.rentprice);
          return acc + (price * parseInt(item.quantity));
        }, 0);

        const totalQuantity = this.products_obj.reduce((acc, item) =>
          acc + parseInt(item.quantity), 0);

        const totalQuantityEl = doc.querySelector('#total-quantity');
        const totalAmountEl = doc.querySelector('#total-amount');

        if (totalQuantityEl) {
          totalQuantityEl.textContent = totalQuantity;
          if (this.isTestUser) totalQuantityEl.classList.add('blurred');
        }
        if (totalAmountEl) {
          totalAmountEl.textContent = totalAmount.toLocaleString('ko-KR');
          if (this.isTestUser) totalAmountEl.classList.add('blurred');
        }
      }
    },

    nextPage() {
      if (this.currentPageIndex < this.localPageUrls.length - 1) {
        this.currentPageIndex++;
        const tabName = this.getTabNameByIndex(this.currentPageIndex);
        if (tabName) {
          this.activeTab = tabName;
          this.checkedTabs = [tabName];
        }
      }
    },
    prevPage() {
      if (this.currentPageIndex > 0) {
        this.currentPageIndex--;
        const tabName = this.getTabNameByIndex(this.currentPageIndex);
        if (tabName) {
          this.activeTab = tabName;
          this.checkedTabs = [tabName];
        }
      }
    },
    closeModal() {
      this.emit('close');
    },

    // ---------------- 한장프린트 -----------------
    printOne() {
      const content = document.getElementById('printContent');
      if (!content) {
        this.$swal.fire('오류', '캡처할 내용이 없습니다.', 'error');
        return;
      }

      this.$swal.fire({
        title: '프린트 준비 중...',
        text: '화면을 캡처하고 있습니다.',
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        }
      });

      // 실제 DOM에서 탭 관련 요소를 모두 숨김
      const tabAreas = content.querySelectorAll('.DocPrintsTabArea, .DocPrintsTab, .preview-container > div:first-child, .preview-container > *:first-child');
      const hiddenElements = [];
      tabAreas.forEach(el => {
        if (el && el.style.display !== 'none') {
          hiddenElements.push({ el, display: el.style.display });
          el.style.display = 'none';
        }
      });

      html2canvas(content, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff'
      }).then(canvas => {
        // 숨긴 요소 복원
        hiddenElements.forEach(({ el, display }) => {
          el.style.display = display;
        });

        const imageData = canvas.toDataURL('image/png');

        const printWindow = window.open('', '_blank');
        if (!printWindow) {
          this.$swal.fire('오류', '팝업이 차단되었습니다. 팝업 차단을 해제해주세요.', 'error');
          return;
        }

        // HTML 문서 작성
        const htmlContent = `
          <!DOCTYPE html>
          <html>
            <head>
              <title>프린트 미리보기</title>
              <style>
                @page {
                  size: A4;
                  margin: 10mm;
                }
                body {
                  margin: 0;
                  padding: 20px;
                  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                  background-color: #f5f5f5;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  min-height: 100vh;
                }
                .toolbar {
                  background: white;
                  padding: 15px;
                  border-radius: 8px;
                  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                  margin-bottom: 20px;
                  display: flex;
                  gap: 10px;
                  align-items: center;
                }
                .print-btn {
                  background: #007bff;
                  color: white;
                  border: none;
                  padding: 10px 20px;
                  border-radius: 5px;
                  cursor: pointer;
                  font-size: 14px;
                  font-weight: 500;
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  transition: background-color 0.2s;
                }
                .print-btn:hover {
                  background: #0056b3;
                }
                .close-btn {
                  background: #6c757d;
                  color: white;
                  border: none;
                  padding: 10px 20px;
                  border-radius: 5px;
                  cursor: pointer;
                  font-size: 14px;
                  font-weight: 500;
                  transition: background-color 0.2s;
                }
                .close-btn:hover {
                  background: #545b62;
                }
                .preview-container {
                  background: white;
                  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
                  border-radius: 8px;
                  overflow: hidden;
                  max-width: 210mm;
                  width: 100%;
                }
                .preview-image {
                  width: 100%;
                  height: auto;
                  display: block;
                }
                .title {
                  margin: 0;
                  color: #333;
                  font-size: 16px;
                  font-weight: 600;
                }
                
                /* 테이블 페이지 브레이크 방지 스타일 */
                table {
                  page-break-inside: auto;
                  border-collapse: collapse;
                  width: 100%;
                }
                
                thead {
                  display: table-header-group;
                }
                
                tbody {
                  display: table-row-group;
                }
                
                tfoot {
                  display: table-footer-group;
                }
                
                tr {
                  page-break-inside: avoid;
                  page-break-after: auto;
                }
                
                th, td {
                  page-break-inside: avoid;
                  word-wrap: break-word;
                  overflow-wrap: break-word;
                }
                
                /* 테이블 행이 페이지 끝에서 잘리지 않도록 */
                tbody tr {
                  orphans: 2;
                  widows: 2;
                }
                
                /* 테이블 헤더가 새 페이지에서 반복되도록 */
                thead tr {
                  break-inside: avoid;
                  break-after: auto;
                }
                
                @media print {
                  body {
                    background: white;
                    padding: 0;
                    margin: 0;
                  }
                  .toolbar {
                    display: none;
                  }
                  .preview-container {
                    box-shadow: none;
                    border-radius: 0;
                    max-width: none;
                  }
                  .preview-image {
                    max-height: none;
                    height: auto;
                    page-break-inside: avoid;
                  }
                  
                  /* 인쇄 시 추가 테이블 보호 */
                  table {
                    page-break-inside: auto;
                    break-inside: auto;
                  }
                  
                  tr {
                    page-break-inside: avoid;
                    break-inside: avoid;
                  }
                  
                  /* 긴 테이블의 경우 적절한 위치에서 분할 */
                  .table-container {
                    page-break-inside: auto;
                  }
                }
              </style>
            </head>
            <body>
              <div class="toolbar">
                <h3 class="title">🖨️ 인쇄 미리보기</h3>
                <button class="print-btn" onclick="window.print()">
                  <span>🖨️</span>
                  인쇄하기
                </button>
                <button class="close-btn" onclick="window.close()">
                  닫기
                </button>
              </div>
              
              <div class="preview-container">
                <img src="${imageData}" alt="프린트 미리보기" class="preview-image" />
              </div>
            </body>
          </html>
        `;
        printWindow.document.write(htmlContent);
        printWindow.document.close();

        // 스크립트를 별도로 추가
        const script = printWindow.document.createElement('script');
        script.textContent = `
          // 키보드 단축키 지원
          document.addEventListener('keydown', function(e) {
            if (e.ctrlKey && e.key === 'p') {
              e.preventDefault();
              window.print();
            }
            if (e.key === 'Escape') {
              window.close();
            }
          });

          // 창 로드 완료 후 포커스
          window.addEventListener('load', function() {
            window.focus();
          });
        `;
        printWindow.document.head.appendChild(script);

        this.$swal.close();
      }).catch(error => {
        hiddenElements.forEach(({ el, display }) => {
          el.style.display = display;
        });
        console.error('프린트 오류:', error);
        this.$swal.fire('오류', '프린트 준비 중 오류가 발생했습니다.', 'error');
      });
    },

    // ---------------- 전체프린트 -----------------
    async printAll() {
      const pageLabels = [
        '거래명세서',
        '세금계산서',
        '견적서'
      ];

      // 체크박스 UI 생성
      const checkboxesHtml = pageLabels.map((label, index) => `
        <div class="checkbox-wrapper" style="margin: 10px 0;">
          <input type="checkbox" 
                id="page-${index}" 
                value="${index}" 
                style="margin-right: 8px;">
          <label for="page-${index}" style="cursor: pointer;">${label}</label>
        </div>
      `).join('');

      const swalInstance = this.$swal;

      const { value: selectedIndices } = await swalInstance.fire({
        title: '프린트할 페이지를 선택하세요',
        html: `
          <div style="text-align: left; margin: 20px auto; max-width: 300px;">
            ${checkboxesHtml}
          </div>
        `,
        showCancelButton: true,
        cancelButtonText: '취소',
        confirmButtonText: '프린트',
        preConfirm: () => {
          const selected = [];
          pageLabels.forEach((_, index) => {
            const checkbox = document.getElementById(`page-${index}`);
            if (checkbox && checkbox.checked) {
              selected.push(index);
            }
          });
          if (selected.length === 0) {
            swalInstance.showValidationMessage('최소 한 페이지를 선택해주세요');
            return false;
          }
          return selected;
        },
        didOpen: (popup) => {
          // 체크박스 이벤트 리스너 추가
          const confirmButton = popup.querySelector('.swal2-confirm');
          pageLabels.forEach((_, index) => {
            const checkbox = document.getElementById(`page-${index}`);
            if (checkbox) {
              checkbox.addEventListener('change', () => {
                const anyChecked = pageLabels.some((_, i) =>
                  document.getElementById(`page-${i}`).checked
                );
                confirmButton.disabled = !anyChecked;
              });
            }
          });
        }
      });

      if (selectedIndices && selectedIndices.length > 0) {
        try {
          this.$swal.fire({
            title: '프린트 준비 중...',
            text: '잠시만 기다려주세요.',
            allowOutsideClick: false,
            didOpen: () => {
              this.$swal.showLoading();
            }
          });

          // 여러 페이지 이미지를 담을 배열
          const images = [];
          const selectedPageLabels = [];

          // 선택된 각 페이지에 대해 캡처
          for (let i = 0; i < selectedIndices.length; i++) {
            const pageIndex = parseInt(selectedIndices[i]);
            selectedPageLabels.push(pageLabels[pageIndex]);

            // 해당 페이지 로드
            await this.loadPage(this.localPageUrls[pageIndex]);
            const content = document.getElementById('printContent');

            // 탭 관련 요소 숨기기 (printOne과 동일)
            const tabAreas = content.querySelectorAll('.DocPrintsTabArea, .DocPrintsTab, .preview-container > div:first-child, .preview-container > *:first-child');
            const hiddenElements = [];
            tabAreas.forEach(el => {
              if (el && el.style.display !== 'none') {
                hiddenElements.push({ el, display: el.style.display });
                el.style.display = 'none';
              }
            });

            // 캡처
            // eslint-disable-next-line no-await-in-loop
            const canvas = await html2canvas(content, {
              scale: 2,
              useCORS: true,
              logging: false,
              backgroundColor: '#ffffff'
            });

            // 숨긴 요소 복원
            hiddenElements.forEach(({ el, display }) => {
              el.style.display = display;
            });

            images.push(canvas.toDataURL('image/png'));
          }

          // 인쇄용 새 창 열기
          const printWindow = window.open('', '_blank');
          if (!printWindow) {
            this.$swal.fire('오류', '팝업이 차단되었습니다. 팝업 차단을 해제해주세요.', 'error');
            return;
          }

          // HTML 문서 작성 (미리보기 포함)
          const htmlContent = `
            <!DOCTYPE html>
            <html>
              <head>
                <title>전체 프린트 미리보기</title>
                <style>
                  @page {
                    size: A4;
                    margin: 10mm;
                    orphans: 2;
                    widows: 2;
                  }
                  body {
                    margin: 0;
                    padding: 20px;
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                    background-color: #f5f5f5;
                  }
                  .toolbar {
                    background: white;
                    padding: 15px;
                    border-radius: 8px;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                    margin-bottom: 20px;
                    display: flex;
                    gap: 10px;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                  }
                  .toolbar-left {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                  }
                  .toolbar-right {
                    display: flex;
                    gap: 10px;
                  }
                  .print-btn {
                    background: #007bff;
                    color: white;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 5px;
                    cursor: pointer;
                    font-size: 14px;
                    font-weight: 500;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    transition: background-color 0.2s;
                  }
                  .print-btn:hover {
                    background: #0056b3;
                  }
                  .close-btn {
                    background: #6c757d;
                    color: white;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 5px;
                    cursor: pointer;
                    font-size: 14px;
                    font-weight: 500;
                    transition: background-color 0.2s;
                  }
                  .close-btn:hover {
                    background: #545b62;
                  }
                  .title {
                    margin: 0;
                    color: #333;
                    font-size: 16px;
                    font-weight: 600;
                  }
                  .page-info {
                    background: #e9ecef;
                    padding: 8px 12px;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #495057;
                  }
                  .pages-container {
                    display: flex;
                    flex-direction: column;
                    gap: 30px;
                  }
                  .page-wrapper {
                    background: white;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.15);
                    border-radius: 8px;
                    overflow: hidden;
                    max-width: 210mm;
                    margin: 0 auto;
                    width: 100%;
                    page-break-inside: avoid;
                  }
                  .page-header {
                    background: #f8f9fa;
                    padding: 10px 15px;
                    border-bottom: 1px solid #dee2e6;
                    font-weight: 500;
                    color: #495057;
                    text-align: center;
                  }
                  .print-img {
                    width: 100%;
                    height: auto;
                    display: block;
                    page-break-inside: avoid;
                  }
                  
                  /* 테이블 페이지 브레이크 방지 스타일 */
                  table {
                    page-break-inside: auto;
                    border-collapse: collapse;
                    width: 100%;
                  }
                  
                  thead {
                    display: table-header-group;
                  }
                  
                  tbody {
                    display: table-row-group;
                  }
                  
                  tr {
                    page-break-inside: avoid;
                    page-break-after: auto;
                  }
                  
                  th, td {
                    page-break-inside: avoid;
                    word-wrap: break-word;
                    overflow-wrap: break-word;
                  }
                  
                  @media print {
                    body {
                      background: white;
                      padding: 0;
                    }
                    .toolbar {
                      display: none;
                    }
                    .pages-container {
                      gap: 0;
                    }
                    .page-wrapper {
                      box-shadow: none;
                      border-radius: 0;
                      max-width: none;
                      page-break-after: always;
                      page-break-inside: avoid;
                      margin: 0;
                    }
                    .page-header {
                      display: none;
                    }
                    .print-img {
                      page-break-after: always;
                      page-break-inside: avoid;
                      max-height: none;
                      height: auto;
                    }
                    .page-wrapper:last-child .print-img {
                      page-break-after: avoid;
                    }
                    
                    /* 인쇄 시 추가 테이블 보호 */
                    table {
                      page-break-inside: auto;
                      break-inside: auto;
                    }
                    
                    tr {
                      page-break-inside: avoid;
                      break-inside: avoid;
                      orphans: 2;
                      widows: 2;
                    }
                    
                    thead tr {
                      break-inside: avoid;
                      break-after: auto;
                    }
                  }
                </style>
              </head>
              <body>
                <div class="toolbar">
                  <div class="toolbar-left">
                    <h3 class="title">🖨️ 전체 프린트 미리보기</h3>
                    <div class="page-info">총 ${images.length}페이지</div>
                  </div>
                  <div class="toolbar-right">
                    <button class="print-btn" onclick="window.print()">
                      <span>🖨️</span>
                      전체 인쇄하기
                    </button>
                    <button class="close-btn" onclick="window.close()">
                      닫기
                    </button>
                  </div>
                </div>
                
                <div class="pages-container">
                  ${images.map((src, idx) => `
                    <div class="page-wrapper">
                      <div class="page-header">
                        ${selectedPageLabels[idx]} (${idx + 1}/${images.length})
                      </div>
                      <img class="print-img" src="${src}" alt="${selectedPageLabels[idx]}" />
                    </div>
                  `).join('')}
                </div>
              </body>
            </html>
          `;
          printWindow.document.write(htmlContent);
          printWindow.document.close();

          // 스크립트를 별도로 추가
          const script = printWindow.document.createElement('script');
          script.textContent = `
            // 키보드 단축키 지원
            document.addEventListener('keydown', function(e) {
              if (e.ctrlKey && e.key === 'p') {
                e.preventDefault();
                window.print();
              }
              if (e.key === 'Escape') {
                window.close();
              }
            });

            // 창 로드 완료 후 포커스
            window.addEventListener('load', function() {
              window.focus();
            });

            // 스크롤 위치 기억
            let scrollPositions = {};
            window.addEventListener('beforeprint', function() {
              scrollPositions.x = window.scrollX;
              scrollPositions.y = window.scrollY;
            });
            
            window.addEventListener('afterprint', function() {
              if (scrollPositions.x !== undefined && scrollPositions.y !== undefined) {
                window.scrollTo(scrollPositions.x, scrollPositions.y);
              }
            });
          `;
          printWindow.document.head.appendChild(script);

          this.$swal.close();
        } catch (error) {
          console.error('프린트 중 오류 발생:', error);
          this.$swal.fire('오류', '프린트 중 문제가 발생했습니다.', 'error');
        }
      }
    },

    // ---------------- 팩스발송 -----------------
    sendFax() {
      this.showModal_obj.fax = true;
    },
    // ---------------- 문자 및 카톡 발송 -----------------
    sendSms() {
      this.showModal_obj.sms = true;
    },
    // ---------------- 전자세금계산서 작성 ----------------- 
    async sendTaxInvoice() {
      try {
        this.$swal.fire({
          title: '전자세금계산서 페이지 준비 중...',
          text: '잠시만 기다려주세요.',
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          }
        });

        const response = await this.$axios.get(`${this.$apiUrls.popbill}/popbill/tax/getTaxURL`, {
          params: {
            CorpNum: '1681102066', // 팝빌회원 사업자번호
            TOGO: 'WRITE', // 세금계산서 작성 페이지
            UserID: 'wjdwhdrkr2', // 팝빌회원 아이디
          }
        });

        await this.$swal.close();

        console.log('팝빌 API 응답:', response.data);

        if (response.data && response.data.url) {
          const popupWidth = 1200;
          const popupHeight = 800;

          const left = (window.innerWidth / 2) - (popupWidth / 2);
          const top = (window.innerHeight / 2) - (popupHeight / 2);

          const popupWindow = window.open(
            response.data.url,
            'TaxInvoiceWrite',
            `width=${popupWidth},height=${popupHeight},left=${left},top=${top},scrollbars=yes,toolbar=no,menubar=no,location=no`
          );

          if (!popupWindow || popupWindow.closed || typeof popupWindow.closed === 'undefined') {
            this.$swal.fire({
              title: '팝업 차단 감지',
              text: '팝업이 차단되었습니다. 팝업 차단을 해제한 후 다시 시도해주세요.',
              icon: 'warning',
              confirmButtonText: '확인'
            });
          } else {
            popupWindow.focus();
          }
        } else {
          console.error('URL이 없는 응답:', response.data);
          if (response.data && typeof response.data === 'object') {
            const errorMessage = response.data.message || '전자계약서 작성 URL을 받아오지 못했습니다.';
            throw new Error(errorMessage);
          } else {
            throw new Error('서버 응답 형식이 올바르지 않습니다.');
          }
        }
      } catch (error) {
        await this.$swal.close();

        this.$swal.fire({
          title: '오류 발생',
          text: `전자계약서 작성 페이지를 열지 못했습니다: ${error.message}`,
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },
    // ---------------- 전자명세서 작성 ----------------- 
    async sendStatement() {
      try {
        this.$swal.fire({
          title: '전자명세서 작성 페이지 준비 중...',
          text: '잠시만 기다려주세요.',
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          }
        });

        const response = await this.$axios.get(`${this.$apiUrls.popbill}/popbill/statement/getStatementURL`, {
          params: {
            CorpNum: '1681102066', // 팝빌회원 사업자번호
            TOGO: 'TBOX', // 세금계산서 작성 페이지
            UserID: 'wjdwhdrkr2', // 팝빌회원 아이디
          }
        });

        await this.$swal.close();

        console.log('팝빌 API 응답:', response.data);

        if (response.data && response.data.url) {
          const popupWidth = 1200;
          const popupHeight = 800;

          const left = (window.innerWidth / 2) - (popupWidth / 2);
          const top = (window.innerHeight / 2) - (popupHeight / 2);

          const popupWindow = window.open(
            response.data.url,
            'TaxInvoiceWrite',
            `width=${popupWidth},height=${popupHeight},left=${left},top=${top},scrollbars=yes,toolbar=no,menubar=no,location=no`
          );

          if (!popupWindow || popupWindow.closed || typeof popupWindow.closed === 'undefined') {
            this.$swal.fire({
              title: '팝업 차단 감지',
              text: '팝업이 차단되었습니다. 팝업 차단을 해제한 후 다시 시도해주세요.',
              icon: 'warning',
              confirmButtonText: '확인'
            });
          } else {
            popupWindow.focus();
          }
        } else {
          console.error('URL이 없는 응답:', response.data);
          if (response.data && typeof response.data === 'object') {
            const errorMessage = response.data.message || '전자계약서 작성 URL을 받아오지 못했습니다.';
            throw new Error(errorMessage);
          } else {
            throw new Error('서버 응답 형식이 올바르지 않습니다.');
          }
        }
      } catch (error) {
        await this.$swal.close();

        this.$swal.fire({
          title: '오류 발생',
          text: `전자계약서 작성 페이지를 열지 못했습니다: ${error.message}`,
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },
    // ---------------- 현금영수증 작성 -----------------
    async sendCashReceipt() {
      try {
        // 문서번호 생성 (현재 날짜 + 시간 + 랜덤숫자)
        const now = new Date();
        const dateStr = now.getFullYear().toString() +
          (now.getMonth() + 1).toString().padStart(2, '0') +
          now.getDate().toString().padStart(2, '0');
        const timeStr = now.getHours().toString().padStart(2, '0') +
          now.getMinutes().toString().padStart(2, '0');
        const randomNum = Math.floor(1000 + Math.random() * 9000); // 4자리 랜덤
        const mgtKey = `CR${dateStr}${timeStr}${randomNum}`;

        this.$swal.fire({
          title: '현금영수증 작성 페이지 준비 중...',
          text: '문서번호 확인 및 URL을 가져오는 중입니다.',
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          }
        });

        // 1단계: 문서번호 사용여부 확인
        const checkResponse = await this.$axios.get(`${this.$apiUrls.popbill}/popbill/receipt/checkMgtKeyInUse`, {
          params: {
            CorpNum: '1681102066', // 팝빌회원 사업자번호
            MgtKey: mgtKey,        // 생성된 문서번호
            UserID: 'wjdwhdrkr2',  // 팝빌회원 아이디
          }
        });

        console.log('문서번호 확인 응답:', checkResponse.data);

        // 문서번호가 이미 사용 중인 경우 새로운 번호 생성
        if (checkResponse.data && checkResponse.data.inUse === true) {
          await this.$swal.close();
          this.$swal.fire({
            title: '문서번호 중복',
            text: '다시 시도해주세요.',
            icon: 'warning',
            confirmButtonText: '확인'
          });
          return;
        }

        // 2단계: 현금영수증 팝업 URL 가져오기
        const urlResponse = await this.$axios.get(`${this.$apiUrls.popbill}/popbill/receipt/getPopUpURL`, {
          params: {
            CorpNum: '1681102066', // 팝빌회원 사업자번호
            MgtKey: mgtKey,        // 확인된 문서번호
            UserID: 'wjdwhdrkr2',  // 팝빌회원 아이디
          }
        });

        await this.$swal.close();

        console.log('현금영수증 URL 응답:', urlResponse.data);

        if (urlResponse.data && urlResponse.data.url) {
          const popupWidth = 1200;
          const popupHeight = 800;

          const left = (window.innerWidth / 2) - (popupWidth / 2);
          const top = (window.innerHeight / 2) - (popupHeight / 2);

          const popupWindow = window.open(
            urlResponse.data.url,
            'CashReceiptWrite',
            `width=${popupWidth},height=${popupHeight},left=${left},top=${top},scrollbars=yes,toolbar=no,menubar=no,location=no`
          );

          if (!popupWindow || popupWindow.closed || typeof popupWindow.closed === 'undefined') {
            this.$swal.fire({
              title: '팝업 차단 감지',
              text: '팝업이 차단되었습니다. 팝업 차단을 해제한 후 다시 시도해주세요.',
              icon: 'warning',
              confirmButtonText: '확인'
            });
          } else {
            popupWindow.focus();

            // 성공 메시지 표시
            this.$swal.fire({
              title: '현금영수증 작성',
              html: `
                <p>현금영수증 작성 페이지가 열렸습니다.</p>
                <p><strong>문서번호:</strong> ${mgtKey}</p>
                <small>팝업 창에서 현금영수증을 작성해주세요.</small>
              `,
              icon: 'success',
              confirmButtonText: '확인',
              timer: 3000,
              timerProgressBar: true
            });
          }
        } else {
          console.error('URL이 없는 응답:', urlResponse.data);
          if (urlResponse.data && typeof urlResponse.data === 'object') {
            const errorMessage = urlResponse.data.message || '현금영수증 작성 URL을 받아오지 못했습니다.';
            throw new Error(errorMessage);
          } else {
            throw new Error('서버 응답 형식이 올바르지 않습니다.');
          }
        }
      } catch (error) {
        await this.$swal.close();

        console.error('현금영수증 작성 오류:', error);

        let errorMessage = '현금영수증 작성 페이지를 열지 못했습니다.';

        if (error.response && error.response.data) {
          // 백엔드에서 반환한 구체적인 오류 메시지 사용
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          } else if (error.response.data.detail) {
            errorMessage = error.response.data.detail;
          }
        } else if (error.message) {
          errorMessage += `: ${error.message}`;
        }

        this.$swal.fire({
          title: '오류 발생',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },

    // ---------------- 테이블 스타일 적용 -----------------
    applyTableStyles() {
      const content = document.getElementById('printContent');
      if (!content) return;

      const tables = content.getElementsByTagName('table');
      for (let table of tables) {
        const trs = table.getElementsByTagName('tr');
        for (let tr of trs) {
          tr.style.height = this.trHeight + 'px';
        }

        const tds = table.getElementsByTagName('td');
        for (let td of tds) {
          if (!td.classList.contains('fix_size')) {
            td.style.width = this.tdWidth + 'px';
          }
        }
      }
    },

    // 거래명세서 처리 수정
    handleTransactionDocument(doc) {
      if (!this.products_obj || !this.client_data_obj) return;

      const tables = doc.getElementsByTagName('table');
      Array.from(tables).forEach(table => {
        // 승인번호 설정 (오늘 날짜 + 랜덤숫자8자리)
        const reg_date = table.querySelector('.reg_date');
        if (reg_date) {
          const today = new Date();
          const year = today.getFullYear();
          const month = String(today.getMonth() + 1).padStart(2, '0');
          const day = String(today.getDate()).padStart(2, '0');
          const dateStr = `${year}${month}${day}`;
          const randomNum = Math.floor(10000000 + Math.random() * 90000000).toString().substring(0, 8);
          reg_date.innerHTML = `${dateStr}-${randomNum}`;

          // test 사용자인 경우 블러 처리
          if (this.isTestUser) {
            reg_date.classList.add('blurred');
          }
        }

        // 공급자 정보 설정 - 블러 처리 추가
        const allRows = table.querySelectorAll('tr');
        allRows.forEach(row => {
          const cells = row.querySelectorAll('td');
          cells.forEach((cell, cellIndex) => {
            const cellText = cell.textContent.trim();
            const isSupplierCell = cell.classList.contains('suplly_td_color');

            if (isSupplierCell && cellText !== '공급자') {
              if (cellText === '등록번호') {
                const nextCell = cell.nextElementSibling;
                if (nextCell && nextCell.colSpan === 3) {
                  nextCell.textContent = this.supplierInfo.registrationNumber || '';
                  if (this.isTestUser) nextCell.classList.add('blurred');
                }
              } else if (cellText === '상호') {
                const nextCell = cell.nextElementSibling;
                if (nextCell) {
                  nextCell.textContent = this.supplierInfo.name || '';
                  if (this.isTestUser) nextCell.classList.add('blurred');
                }
              } else if (cellText === '성명') {
                const nextCell = cell.nextElementSibling;
                if (nextCell) {
                  nextCell.textContent = this.supplierInfo.representative || '';
                  if (this.isTestUser) nextCell.classList.add('blurred');
                }
              } else if (cellText === '주소') {
                const nextCell = cell.nextElementSibling;
                if (nextCell && nextCell.colSpan === 3) {
                  nextCell.textContent = this.supplierInfo.address || '';
                  if (this.isTestUser) nextCell.classList.add('blurred');
                }
              } else if (cellText === '업태') {
                const nextCell = cell.nextElementSibling;
                if (nextCell) {
                  nextCell.textContent = this.supplierInfo.business || '';
                  if (this.isTestUser) nextCell.classList.add('blurred');
                }
              } else if (cellText === '종목') {
                const nextCell = cell.nextElementSibling;
                if (nextCell) {
                  nextCell.textContent = this.supplierInfo.item || '';
                  if (this.isTestUser) nextCell.classList.add('blurred');
                }
              } else if (cellText === '이메일') {
                const nextCell = cell.nextElementSibling;
                if (nextCell && nextCell.colSpan === 3) {
                  nextCell.textContent = this.supplierInfo.email || '';
                  if (this.isTestUser) nextCell.classList.add('blurred');
                }
              } else if (cellText === '담당자') {
                const nextCell = cell.nextElementSibling;
                if (nextCell && nextCell.colSpan === 3) {
                  nextCell.textContent = this.supplierInfo.manager || '';
                  if (this.isTestUser) nextCell.classList.add('blurred');
                }
              } else if (cellText === '연락처') {
                const nextCell = cell.nextElementSibling;
                if (nextCell && nextCell.colSpan === 3) {
                  nextCell.textContent = this.supplierInfo.phone || '';
                  if (this.isTestUser) nextCell.classList.add('blurred');
                }
              }
            }
          });
        });

        // 공급받는자(고객) 정보 설정 - 블러 처리 추가
        allRows.forEach(row => {
          const cells = row.querySelectorAll('td');
          cells.forEach((cell, cellIndex) => {
            const cellText = cell.textContent.trim();
            const isClientCell = cell.classList.contains('td_color') &&
              !cell.classList.contains('btransaction_client_title') &&
              cellText !== '공급받는자';

            if (isClientCell) {
              if (cellText === '등록번호') {
                const nextCell = cell.nextElementSibling;
                if (nextCell && nextCell.colSpan === 3) {
                  nextCell.textContent = this.client_data_obj.company_bnum || '';
                  if (this.isTestUser) nextCell.classList.add('blurred');
                }
              } else if (cellText === '상호') {
                const nextCell = cell.nextElementSibling;
                if (nextCell) {
                  nextCell.textContent = this.client_data_obj.company || '';
                  if (this.isTestUser) nextCell.classList.add('blurred');
                }
              } else if (cellText === '성명') {
                const nextCell = cell.nextElementSibling;
                if (nextCell) {
                  nextCell.textContent = this.client_data_obj.company_ceo_name || '';
                  if (this.isTestUser) nextCell.classList.add('blurred');
                }
              } else if (cellText === '주소') {
                const nextCell = cell.nextElementSibling;
                if (nextCell && nextCell.colSpan === 3) {
                  const address = this.postcode_obj ?
                    `${this.postcode_obj.address1} ${this.postcode_obj.detailAddress1}` :
                    (this.client_data_obj.company_address || '');
                  nextCell.textContent = address;
                  if (this.isTestUser) nextCell.classList.add('blurred');
                }
              } else if (cellText === '업태') {
                const nextCell = cell.nextElementSibling;
                if (nextCell) {
                  nextCell.textContent = this.client_data_obj.company_type || '';
                  if (this.isTestUser) nextCell.classList.add('blurred');
                }
              } else if (cellText === '종목') {
                const nextCell = cell.nextElementSibling;
                if (nextCell) {
                  nextCell.textContent = this.client_data_obj.company_industry || '';
                  if (this.isTestUser) nextCell.classList.add('blurred');
                }
              } else if (cellText === '이메일') {
                const nextCell = cell.nextElementSibling;
                if (nextCell && nextCell.colSpan === 3) {
                  nextCell.textContent = this.client_data_obj.company_email || '';
                  if (this.isTestUser) nextCell.classList.add('blurred');
                }
              } else if (cellText === '담당자') {
                const nextCell = cell.nextElementSibling;
                if (nextCell && nextCell.colSpan === 3) {
                  nextCell.textContent = this.client_data_obj.user_name || '';
                  if (this.isTestUser) nextCell.classList.add('blurred');
                }
              } else if (cellText === '연락처') {
                const nextCell = cell.nextElementSibling;
                if (nextCell && nextCell.colSpan === 3) {
                  nextCell.textContent = this.client_data_obj.company_phone || '';
                  if (this.isTestUser) nextCell.classList.add('blurred');
                }
              }
            }
          });
        });

        // 작성일자 설정 - 블러 처리 추가
        const tradeDateRows = table.querySelectorAll('tr');
        for (let i = 0; i < tradeDateRows.length; i++) {
          const firstCell = tradeDateRows[i].querySelector('td:first-child');
          if (firstCell && firstCell.textContent === '작성일자') {
            const dateCell = tradeDateRows[i].querySelector('td:nth-child(2)');
            if (dateCell) {
              if (this.client_data_obj.orderdate) {
                dateCell.textContent = this.client_data_obj.orderdate;
                if (this.isTestUser) dateCell.classList.add('blurred');
              }
            }
            break;
          }
        }

        // 제품 정보 처리 - 블러 처리 추가
        const products_tr_col = table.querySelector('.products_tr_col');
        if (products_tr_col) {
          const existingRows = table.querySelectorAll('.product-row');
          existingRows.forEach(row => row.remove());

          const rows = [];

          this.products_obj.forEach((item, index) => {
            const tr = document.createElement('tr');
            tr.className = 'product-row';

            const price = item.selected_target === '구입' ?
              parseInt(item.buyprice) :
              parseInt(item.rentprice);
            const quantity = parseInt(item.quantity);
            const supplyAmount = price * quantity;
            const taxAmount = Math.floor(supplyAmount * 0.1);

            tr.innerHTML = `
              <td class="tg-0lax td_color">${index + 1}</td>
              <td class="tg-0lax td_color" colspan="2">${parseInt(item.b_product_id) >= 1000000 ? item.name3 : item.name2}</td>
              <td class="tg-0lax td_color">${item.options.size[0] || ''}</td>
              <td class="tg-0lax td_color">${quantity}</td>
              <td class="tg-0lax td_color" colspan="2">${price.toLocaleString('ko-KR')}</td>
              <td class="tg-0lax td_color">${supplyAmount.toLocaleString('ko-KR')}</td>
              <td class="tg-0lax td_color">${taxAmount.toLocaleString('ko-KR')}</td>
              <td class="tg-0lax td_color">${item.selected_target || ''}</td>
            `;

            // test 사용자인 경우 모든 셀에 블러 처리
            if (this.isTestUser) {
              const cells = tr.querySelectorAll('td');
              cells.forEach(cell => cell.classList.add('blurred'));
            }

            rows.push(tr);
          });

          const nextRow = products_tr_col.nextElementSibling;
          rows.forEach(row => {
            table.querySelector('tbody').insertBefore(row, nextRow);
          });
        }

        // 합계 금액 계산 및 표시 - 블러 처리 추가
        const total_price = table.querySelectorAll('.total_price');
        if (total_price) {
          let totalSupply = 0;
          let totalTax = 0;

          this.products_obj.forEach(item => {
            const price = item.selected_target === '구입'
              ? parseInt(item.buyprice)
              : parseInt(item.rentprice);
            const quantity = parseInt(item.quantity);
            const supplyAmount = price * quantity;
            const taxAmount = Math.floor(supplyAmount * 0.1);

            totalSupply += supplyAmount;
            totalTax += taxAmount;
          });

          if (total_price.length >= 3) {
            total_price[0].innerHTML = (totalSupply + totalTax).toLocaleString('ko-KR');
            if (this.isTestUser) total_price[0].classList.add('blurred');
          }
        }

        // 고객 정보 설정 - 블러 처리 추가
        const client_name = table.querySelector('.client_name');
        if (client_name && this.client_data_obj) {
          client_name.innerHTML = this.client_data_obj.name;
          if (this.isTestUser) client_name.classList.add('blurred');
        }

        const client_address = table.querySelector('.client_address');
        if (client_address && this.postcode_obj) {
          client_address.innerHTML = `${this.postcode_obj.address1} ${this.postcode_obj.detailAddress1}`;
          if (this.isTestUser) client_address.classList.add('blurred');
        }

        const client_phone = table.querySelector('.client_phone');
        if (client_phone && this.client_data_obj) {
          client_phone.innerHTML = this.client_data_obj.phone1;
          if (this.isTestUser) client_phone.classList.add('blurred');
        }
      });
    },

    onlyNumber(value, target) {
      const num = value.replace(/[^0-9]/g, '');
      if (target === 'trHeight') {
        this.trHeight = num;
      } else if (target === 'tdWidth') {
        this.tdWidth = num;
      }
      this.setTableStyles();
    },
    setTableStyles() {
      this.applyTableStyles();
    }
  },

  mounted() {
    document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.addEventListener('click', (e) => e.stopPropagation());
    });

    // 로컬스토리지에서 공급자 정보 로드
    this.loadSupplierInfoFromStorage();

    // 기본 페이지 URL 설정
    if (!this.pageUrls || this.pageUrls.length < 4) {
      // 부모 컴포넌트에서 전달된 URL이 없거나 4개 미만인 경우, 기본 URL 사용
      const serverUrl = this.pageUrls && this.pageUrls.length > 0 ?
        new URL(this.pageUrls[0]).origin :
        'http://172.30.1.94:8080';

      this.localPageUrls = [
        `${serverUrl}/btransactionfileNew.html`,    // 거래명세서 템플릿
        `${serverUrl}/taxfileNew.html`,             // 세금계산서 템플릿
        `${serverUrl}/estimatefileNew.html`,        // 견적서 템플릿
      ];
    } else {
      // 부모 컴포넌트에서 전달된 URL이 있는 경우 그대로 사용
      this.localPageUrls = [...this.pageUrls];
    }

    // 첫 페이지 로드 및 초기화
    this.loadPage(this.localPageUrls[0]);
    this.activeTab = '거래명세서';
    this.checkedTabs = ['거래명세서'];
    this.currentPageIndex = 0;
  },

  watch: {
    currentPageIndex: function (newVal) {
      this.loadPage(this.localPageUrls[newVal]);
    },
    pageUrls: {
      handler(newUrls) {
        if (newUrls && newUrls.length > 0) {
          this.localPageUrls = [...newUrls];
        }
      },
      immediate: true
    },
  }
};
</script>

<style>
/* 블러 효과를 위한 CSS - 특정 컨테이너 내부에만 적용 */
.preview-page .blurred {
  filter: blur(8px) !important;
  pointer-events: auto;
  user-select: auto;
  -webkit-user-select: auto;
  -moz-user-select: auto;
  -ms-user-select: auto;
}

/* 블러된 요소 내부의 상호작용은 유지 */
.preview-page .blurred * {
  pointer-events: auto;
  user-select: auto;
  -webkit-user-select: auto;
  -moz-user-select: auto;
  -ms-user-select: auto;
}

/* 특정 요소들에 대한 블러 효과 강화 - preview-page 내부에만 */
.preview-page .blurred td,
.preview-page .blurred div,
.preview-page .blurred span {
  filter: blur(8px) !important;
}

/* 블러 처리되지 않은 요소들은 명시적으로 블러 해제 */
.preview-page *:not(.blurred) {
  filter: none !important;
}

/* 모달 자체나 다른 UI 요소들은 블러 처리하지 않음 */
.modal-overlay,
.modal-content,
.DocPrintsArea,
.DocPrintsBtnArea,
.DocPrintsTabArea,
.DocPrintsArrowArea {
  filter: none !important;
}
</style>